let articleHostNew = 'https://www.qiyewan.com:7000/v1'
// let articleHostNew = 'http://127.0.0.1:8000/v1'
import http from '../utils/fetch'


const ArticleFetch = function () {
  // const _c = {
  //   withCredentials: false,
  // }
  const articleHeaders = {
    'Access-Control-Allow-Origin': window.location.host,
  }

  return {
    get: function ({url, params, data}) {
      // debugger
      let absUrl = `${articleHostNew}${url}`;
      return http.get({
        url: absUrl,
        params: params,
        data: data,
        // headers: articleHeaders,
        withCredentials: false,
      })
    },
  }
}
const articleFetch = ArticleFetch()


export default {
  getAuthor(id, success, error) {
    // debugger
    articleFetch.get({url: `/authors/${id}/`})
      .then(response => success(response),
        response => error(response))
  },
  getArticles(params, success, error) {
    /**
     * page_size = 10
     * @type {string}
     */
    let url = `/articles/?page=${params.page || ''}&page_size=${params.pageSize || ''}&hot=${params.hot || ''}&category=${params.category || ''}&tag=${params.tag || ''}&author=${params.author || ''}`
    // console.log(url)
    // debugger
    articleFetch.get({url: url}).then(response => success(response), response => error(response))
  },
  getRecommendedArticles(params, success, error) {
    params.recommended = 1
    params.pageSize = 7
    params.page = 1
    let url = `/articles/?page=${params.page || ''}&page_size=${params.pageSize || ''}&recommended=1`
    // debugger
    articleFetch.get({url: url}).then(response => success(response), response => error(response))
  },
  getHotArticles(params, success, error) {
    params.hot = 1
    params.pageSize = 7
    params.page = 1
    let url = `/articles/?page=${params.page || ''}&page_size=${params.pageSize || ''}&hot=${params.hot || ''}&category=${params.category || ''}&tag=${params.tag || ''}`
    // debugger
    articleFetch.get({url: url})
      .then(response => success(response), response => error(response))
  },
  getArticleById (articleId) {
    return new Promise((resolve, reject) => {
      articleFetch.get({url: `/articles/${articleId}/`})
        .then(response => resolve(response), response => reject(response))
    })
  },
  getTags(success, error) {
    articleFetch.get({url: `/tags/`})
      .then(response => success(response), response => error(response))
  },
  getCategories(success, error) {
    articleFetch.get({url: `/categories/`})
      .then(response => success(response), response => error(response))
  },

}



// WEBPACK FOOTER //
// ./src/api/article.js